<ng-container *ngIf="getDepartments() as departments">
  <scope-departments-header
    *ngIf="!config?.isTimeline && departments?.length > 0"
    [config]="config"
    [level]="level">
  </scope-departments-header>

  <scope-departments-row
    *ngFor="let department of departments; trackBy: trackById"
    [component]="component"
    [department]="department"
    [config]="config"
    [level]="level"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)">
  </scope-departments-row>
</ng-container>
